import React from 'react';

class Footer extends React.Component {
    render() {
        return (
            <div className="col-md-12 no-sm-h-padding">
                <div className="col-md-12 footer-section" style={{background: localStorage.footerBgColor, color:localStorage.footerTextColor}}>
                    <div className="row  mb-3">                
                        <div className="col-md-4 col-sm-4 m-auto pt-2 pb-2 xs-w20 xs-no-padding">
                            {/* <p style={{color:localStorage.footerTextColor}}><b>CJ Live Presentation </b> {localStorage.inqueryNumber !== 'null' ? localStorage.inqueryNumber : ''}</p>                    */}
                            <p style={{color:localStorage.footerTextColor}}><b>{localStorage.helpline}</b></p>                   
                        </div>
                        <div className="text-center col-md-4 col-sm-4 m-auto pt-2 pb-2 xs-w20 xs-no-padding">
                            {localStorage.programId != 'fe150217-61af-4e2a-8a84-68feb2d66cde' &&
                            <p>
                                <b style={{color:localStorage.footerTextColor}}>Powered By </b>
                                <a href="https://gocon.live" className="Copyright_link" style={{color:localStorage.footerTextColor}}>ComJagat Technologies Limited</a>
                            </p>
                            }
                        </div>

                        <div className="col-md-4 col-sm-4 m-auto xs-w20 xs-no-padding">
                            <p className="right">
                                <b style={{color:localStorage.footerTextColor}}>GOCON ED v 2.2.1</b>
                            </p>
                            <span className="clear"></span>
                                    
                        </div>                
                    </div>
                </div>
            </div>
        );
    }
}

export default Footer;